import Analytics from '@opencare/analytics';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { useAnalyticsService } from 'services/AnalyticsService';

import SingleSelect from '../../../../../common/components/SingleSelect/SingleSelect';
import {
  OptionBlock,
  Subtitle,
  Title,
} from '../../../../../common/styled-components';
import { useFunnelStorage } from '../../../../storage/Storage';
import { StepWrapper } from '../../../../styled-components';
import { generateStepAnalytics, STEP_KEY } from '../../../../utils';
import { SUBSTEPS } from '../../constants';

import { options } from './constants';

const analytics = new Analytics();

const AltPaymentPlans = ({ position, moveToNextStep, setSubStep }) => {
  const storage = useFunnelStorage();
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_alt-payment-plans',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const handleOptionSelected = (option, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_alt-payment-plans',
      name: 'wizard',
      section: 'alt-payment-plans',
      position: [index + 1],
      ...generateStepAnalytics(position, storage, {
        response: option.id,
      }),
    });

    // Insurance is complete unless using social assistance
    const isComplete = option.allowProgression === true;

    storage.save(
      STEP_KEY.INSURANCE,
      {
        hasInsurance: 'No',
        altPaymentPlanInterest: option.id,
      },
      isComplete,
    );

    if (isComplete) {
      moveToNextStep();
    } else {
      setSubStep(SUBSTEPS.NOT_ELIGIBLE);
    }
  };

  return (
    <div data-testid="substep-alt-payment-plans">
      <Title id="title">
        Are you interested in exploring alternative payment options with your
        dentist?
      </Title>
      <Subtitle data-testid="example-payment-plans">
        e.g. in-house discount plans, financing
      </Subtitle>
      <StepWrapper>
        <form>
          <OptionBlock row={2}>
            {options.map((option, i) => (
              <SingleSelect
                key={option.id}
                id={option.id}
                title={option.title}
                description={option.description}
                describedBy="title"
                onChange={() => handleOptionSelected(option, i)}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

AltPaymentPlans.defaultProps = {
  position: '',
};

AltPaymentPlans.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
  setSubStep: PropTypes.func.isRequired,
};

export default AltPaymentPlans;
